import styled from 'styled-components';

const Slogan = styled.h1`
    margin: 0px;
    font-size: 82px;
    line-height: 88px;
    max-width: 1968px;
    font-weight: 600;
    text-align: center;
    padding:60px 0;

    @media (max-width: 768px) {
        font-size: 50px;
    }
`;

export default Slogan;
